// top level orchestration - for the view
var controllerEvents = require('ControllerEvents.js');


var ViewController = function ($, ko, _, core, helpers, events, interControllerEmitter, console, titleMap) {

    var self = this,
    update = _.noop, setTimeoutUpdate = function () { update(), setTimeout(update, 100), setTimeout(update, 300) }// set to resize panels

    self.greetingText = 'Powered by Fieldology';
    self.mainViewComponent = ko.observable();
    self.mainViewParams    = ko.observable();

    self.specificInfo      = ko.observable();
    self.specificError     = ko.observable();
    self.specificSuccess   = ko.observable();
    self.specificWarning   = ko.observable();

    self.busyMessages      = ko.observableArray(['Starting Fusion']);

    self.loggedIn          = ko.observable();
    self.userNameDisplay   = ko.observable('Menu');
    self.title             = ko.observable('');
    self.orange            = ko.observable();
    self.footerVisible     = ko.observable();
    self.grid              = ko.observable();
    self.LayoutChoice      = ko.observable();
    self.fullpageActive    = ko.observable(true);

    
    [{ event: events.info   , observable: self.specificInfo    },
     { event: events.error  , observable: self.specificError   },
     { event: events.success, observable: self.specificSuccess },
     { event: events.warning, observable: self.specificWarning }
    ].forEach(function (x) { events.emitter.on(x.event, x.observable); x.observable.subscribe(setTimeoutUpdate) })


    
    self.logOut = function(){

        console.log('blah: logOut :: logOut');

        _cachedFilters = null;
        _cachedPrimaryFilters = null;

      //  self.goToSplashScreen();
    }
        
    
    events.emitter.on(events.resize, function (resize) { resize && self.fullpageActive(resize.isPageHeight) });

    events.emitter.on(events.busy_message, function(message){ self.busyMessages(_.concat(message, self.busyMessages())) });

    events.emitter.on(events.log_out, self.logOut );
    
    self.goToSplashScreen = function(argOverride){

        console.log('goToSplashScreen', 0);

        var model = { InterControllerEmitter : interControllerEmitter }

        return self.applicationStateController.getCurrentGalleryKey()

            .then(function(currentGalleryKey){

                console.log('goToSplashScreen', 1 , currentGalleryKey);                

                _.assign(model, { RequestGalleryKey: (argOverride && argOverride.RequestGalleryKey) || !currentGalleryKey, CurrentGalleryKey: currentGalleryKey ? currentGalleryKey.GalleryKey : undefined });
            
                return self.applicationStateController.getAll();

            })
            .then(function(history){

                console.log('goToSplashScreen', 2 , history);

                _.assign(model, { History : history });

                setMainViewComponent('SplashScreen', model);
            
            })
    }
    self.toggleFullScreen = function () { self.fullpageActive(!self.fullpageActive()); update() }

    var initParams = { CallId: null };

    // todo:restrict transition to valid next states/views
    var setMainViewComponent = function (viewName, params,customTitle) {
        
        var componentName = viewName.toLowerCase() + '-view', footer = _.includes(['Call', 'Grid'], viewName);
        console.error('setting view', componentName);
        self.mainViewComponent(componentName).mainViewParams(params).orange(viewName === 'Splash').grid(viewName === 'Grid').title(customTitle ? customTitle : titleMap[componentName]).footerVisible(footer);
        setTimeoutUpdate();
        footer && interControllerEmitter.emit(controllerEvents.request_can_save);
        return self;
    }

     interControllerEmitter.on(controllerEvents.splashscreen_view_request, function () {
        return self.goToSplashScreen();
     });

     interControllerEmitter.on(controllerEvents.log_out, function () {

        console.log('view controller logout');

        return self.logOut();
     });

    interControllerEmitter.on(controllerEvents.grid_request, function (data, layoutChoice) {

        setMainViewComponent('Grid', { Data: data, LayoutChoice: layoutChoice }).LayoutChoice(layoutChoice);
    });

    var _cachedFilters = null, getsetCachedFilters  = function(set){ return set ? (_cachedFilters = set) : _cachedFilters }
    var _cachedPrimaryFilters = null, getsetCachedPrimaryFilters  = function(set){ return set ? (_cachedPrimaryFilters = set) : _cachedPrimaryFilters }

    var galleryDetails, setGalleryDetails = function(details){ galleryDetails = details }

    interControllerEmitter.on(controllerEvents.gallery_details_loaded, setGalleryDetails);

    var setSplitView = function (context) {
        
        self.applicationStateController && self.applicationStateController.getCurrentGalleryKey()
        .then(function(currentGalleryKey){

            if (currentGalleryKey && galleryDetails){
                var vmparams = {   GalleryKey              : currentGalleryKey.GalleryKey
                                 , InterControllerEmitter  : interControllerEmitter
                                 , Context                 : context ||  { LeftHandView: 'PictureFilters', RightHandView: 'PictureGrid' }
                                 , GalleryDetails          : currentGalleryKey       
                                 , GalleryDetails2         : galleryDetails                       
                                 , CachedFilters           : getsetCachedFilters                 
                                 , CachedPrimaryFilters    : getsetCachedPrimaryFilters                 
                                                                                        }

                                 console.error('vmparams', vmparams );

                setMainViewComponent('Split', vmparams, 'Gallery');
            }
        })

    }

    interControllerEmitter.on(controllerEvents.split_view_request, setSplitView);
 
    self.SelectLayoutChoice = function (selection) { console.info(selection); self.LayoutChoice(selection.value); events.emitter.emit(events.grid_layout, selection.value) };

    self.userLogsOn = ko.observable();

    self.logOut = function () { interControllerEmitter.emit(controllerEvents.user_logout) }

    
    self.wakeup = function(){ console.info('wake up');  setMainViewComponent('InfoDisplay', { initCallId: null, callInfo: null }) }
    
    self.init = function (params, startupState, applicationStateController) {
        
        initParams = params;
        _.assign(self, {
            params: params
            , applicationStateController: applicationStateController
            , getApplicationState: applicationStateController.getApplicationState
        });

        console.error('ViewController - init', self, params, startupState);

        if (params.fullPage) {

            $('#placementPlatform').css({ width: '100%', height: 1200, 'background-color': 'white' });

            update = helpers.makeFullPageUpdate(self.fullpageActive, $('#dtaCapHdr'), $('#dtaCapFtr'), $('#dtaCapMdl'), $('#DataCaptureAppView'), $('#placementPlatform'), $(window), events);

        } else {

            $('#placementPlatform').css({ width: '100%', height: _.parseInt(params.height), 'background-color': 'white' });
            //               makeCompactUpdate(_fullsize          , header         , footer         , middle         , shell                   , platform               , $window  , events)
            update = helpers.makeCompactUpdate(self.fullpageActive, $('#dtaCapHdr'), $('#dtaCapFtr'), $('#dtaCapMdl'), $('#DataCaptureAppView'), $('#placementPlatform'), $(window), events);

        }

        $(window).resize(helpers.startBurst(update, 10, 30)).scroll(update);
        $('*[data-toggle="collapse"]').click(   helpers.startBurst(update, 40, 30)); 
        events.emitter.on(events.layout_change, helpers.startBurst(update, 40, 30));

                
        if(startupState.startupview == 'callsearch'){ return setMainViewComponent('InfoDisplay', { initCallId: null         , callInfo: null }) }       
        if(startupState.startupview == 'Info'      ){ return setMainViewComponent('InfoDisplay', { initCallId: params.callId, callInfo: null }  )}
        if(startupState.startupview == 'history'   ){        setMainViewComponent('History'    ,   startupState                                 )
                                                      throw 'history ends';
                                                    }
        
        if(startupState.startupview == 'direct'    ){ console.warn('direct through to split view'); return setSplitView() }

        //setMainViewComponent('SplashScreen', {InterControllerEmitter : interControllerEmitter,RequestGalleryKey: startupState.startupview === 'gallerykeyinputneeded'})
        self.userLogsOn(!params.sessionToken);
        
        self.goToSplashScreen({ RequestGalleryKey: startupState.startupview === 'gallerykeyinputneeded'})

    }    
    


}

module.exports = ViewController;

